import { useTranslation } from 'react-i18next'

import { isSubArchive } from '../../../../utils/route'
import { ProfileAISummaryWidget } from '../../../Widget'
import { useEmailProfileContext } from '../../Email.hooks'
import { EMAIL_PROFILE_WIDGET_QA_NAME_AI_SUMMARY } from '../EmailProfileWidget.constants'

import * as styles from './EmailProfileAISummaryWidget.module.css'

function EmailProfileAISummaryWidget({
  className = styles.EmailProfileAISummaryWidget,
  isSkeleton,
  ...restProps
}) {
  const { t } = useTranslation()

  const { entityData, sub, summaryProps } = useEmailProfileContext()

  return (
    <ProfileAISummaryWidget
      {...summaryProps}
      {...restProps}
      className={className}
      isArchived={entityData?.soft_archived ?? isSubArchive(sub)}
      isSkeleton={isSkeleton || !summaryProps.data}
      qaName={EMAIL_PROFILE_WIDGET_QA_NAME_AI_SUMMARY}
      textProps={{
        warningText: t('Common.ProfileWidgetAISummaryWarningTextKey'),
      }}
    />
  )
}

export default EmailProfileAISummaryWidget
